export const getPromoNumberOfMonthes = (promoCode) => {
  const numberOfMonthes = promoCode.match(/(03|06|12|24)/);
  if (numberOfMonthes) {
    return Number(numberOfMonthes[0]);
  } else {
    return 0;
  }
};
